import React, { useEffect, useState } from "react";
import "./_ActionsCard.scss";
import { ReactComponent as PhoneIcon } from "../../../../assets/images/ManagementSaleOrg/phone.svg";
import { ReactComponent as WhatsIcon } from "../../../../assets/images/ManagementSaleOrg/whats.svg";
import { useTranslation } from "react-i18next";
import CalendarDates from "../../../../components/CalendarDates/CalendarDates";
import cookies from "js-cookie";
import { useSelector } from "react-redux";
import { Button, Tooltip } from "antd";
import "./AuctionCard.css";
import ActionModal from "../../../../components/Modals/ActionModal";
import { allValuesFalsy } from "../../../../helpers/allValuesFalsy";
import MsgCallButtons from "../../../../components/MsgCallButtons/MsgCallButtons";

function ActionCard({ propertieItem, type, category }) {
  const [screenWidth, setScreenWidth] = useState(window.innerWidth);
  useEffect(() => {
    const handleResize = () => {
      setScreenWidth(window.innerWidth);
    };

    window.addEventListener("resize", handleResize);

    // Cleanup function to remove the event listener when component unmounts
    return () => {
      window.removeEventListener("resize", handleResize);
    };
  }, []); // Empty dependency array ensures the effect runs only once after the component mounts

  const { t } = useTranslation();

  const lang = cookies.get("i18next") || "en";

  const [open, setOpen] = useState(false);

  console.log(screenWidth);

  return (
    <div>
      <div
        className={
          propertieItem?.offer_type === "sell"
            ? "more-info-container more-info-container-space"
            : "more-info-container "
        }
      >
        {open && (
          <ActionModal
            open={open}
            id={propertieItem.refId}
            handleClose={() => setOpen(false)}
            propertieItem={propertieItem}
          />
        )}
        {propertieItem?.offer_type === "sell" && (
          <button className="btn">
            {t("properties.Toll")} {propertieItem?.price?.toll_price?.price}{" "}
            {propertieItem?.currency_key}
            <span>
              {propertieItem?.price?.toll_price?.price_per_meter}{" "}
              {t("properties.RS_meter")}
            </span>
          </button>
        )}

        {propertieItem?.offer_type === "rent" && (
          <div className="pay-method">
            <p className="pay_m">{t("properties.Payment method")} </p>{" "}
            {propertieItem?.price?.payment_method
              ?.split(",")
              ?.map((item, index) => (
                <span key={index} className="pay_tag">
                  {item}
                </span>
              ))}
          </div>
        )}

        {propertieItem?.offer_type === "daily_rent" &&
        propertieItem?.available &&
        propertieItem?.property_default_price != 0 ? (
          <Tooltip
            color="white"
            className="tool-tip-price daily_rent_tooltip"
            title={
              <p className="tooltip-color">
                {propertieItem?.total && t("properties.per_day")}
              </p>
            }
          >
            <button className="btn">
              {propertieItem?.total} {propertieItem?.currency_key}
            </button>
          </Tooltip>
        ) : (
          type !== "auction" && <span className="no-available-title"></span>
        )}

        {type !== "auction" && (
          <div className="contact-info">
            {propertieItem?.user_property_ref_id && (
              <Tooltip
                color="white"
                title={
                  <p className="tooltip-color">{t("properties.propertyNo")}</p>
                }
              >
                <p className="ref-id">{propertieItem?.user_property_ref_id}</p>
              </Tooltip>
            )}
            {propertieItem?.user_details?.selling_agent?.image && (
              <img
                src={propertieItem?.user_details?.selling_agent?.image}
                alt="logo"
                className="logo_property"
              />
            )}
            <div className="contact-btn">
              <MsgCallButtons
                type="whatsapp"
                whtsappNumber={propertieItem.whatsapp}
                id={propertieItem.id}
                userPropertyRefID={propertieItem.user_property_ref_id}
                name={propertieItem.name}
                offerType={propertieItem.offer_type}
              />
            </div>
            <div className="contact-btn">
              <MsgCallButtons
                type="call"
                id={propertieItem.id}
                phoneNumber={propertieItem.phone}
                offerType={propertieItem.offer_type}
              />
            </div>
            {propertieItem?.offer_type === "daily_rent" && (
              <>
                <CalendarDates
                  availableDays={propertieItem?.available_days}
                  all_days_available={propertieItem?.all_days_available}
                  all_days_available_price={
                    propertieItem?.property_default_price
                  }
                  removeDates={propertieItem?.removed_dates}
                  currentLanguage={lang}
                />
              </>
            )}
          </div>
        )}

        {type === "auction" && (
          <>
            <div className="webpage">
              {screenWidth < 820 ? (
                <div className="countdown-container">
                  <div className="date-wrapper">
                    <div className="date-number">
                      {propertieItem?.auction?.date?.day}
                    </div>
                    <div className="date-text">
                      {" "}
                      {t("auction_elements.days")}
                    </div>
                  </div>
                  <div className="date-wrapper">
                    <div className="date-number">
                      {propertieItem?.auction?.date?.hours}:
                      {propertieItem?.auction?.date?.minutes}
                    </div>
                    <div className="date-text">
                      {" "}
                      {t("auction_elements.hours")}
                    </div>
                  </div>
                </div>
              ) : (
                <div className="countdown-container">
                  <div className="date-wrapper">
                    <div className="date-number">
                      {propertieItem?.auction?.date?.day}
                    </div>
                    <div className="date-text">
                      {" "}
                      {t("auction_elements.days")}
                    </div>
                  </div>
                  <div className="date-wrapper">
                    <div className="date-number">
                      {propertieItem?.auction?.date?.hours}
                    </div>
                    <div className="date-text">
                      {" "}
                      {t("auction_elements.hours")}
                    </div>
                  </div>
                  <div className="date-wrapper">
                    <div className="date-number">
                      {propertieItem?.auction?.date?.minutes}
                    </div>
                    <div className="date-text">
                      {" "}
                      {t("auction_elements.minutes")}
                    </div>
                  </div>
                </div>
              )}
              {propertieItem?.auction &&
                propertieItem?.auction?.auction_type === "offline" && (
                  <Tooltip
                    color="white"
                    className="icon-wrapper"
                    title={
                      <p className="tooltip-color">
                        {t("property_details_auction.tooltips.offline")}
                      </p>
                    }
                  >
                    <svg
                      width="20"
                      height="20"
                      viewBox="0 0 20 20"
                      fill="none"
                      xmlns="http://www.w3.org/2000/svg"
                    >
                      <path
                        fill-rule="evenodd"
                        clip-rule="evenodd"
                        d="M0.791045 5.97494C0.636234 6.12971 0.513429 6.31346 0.429644 6.5157C0.345858 6.71793 0.302734 6.9347 0.302734 7.1536C0.302734 7.37251 0.345858 7.58927 0.429644 7.79151C0.513429 7.99375 0.636234 8.1775 0.791045 8.33227L2.67704 10.2176C2.92441 10.4647 3.24325 10.6278 3.58842 10.6838C3.9336 10.7397 4.28762 10.6857 4.60038 10.5293C4.91314 10.3729 5.16879 10.1221 5.33115 9.8124C5.4935 9.50271 5.55434 9.14979 5.50504 8.8036L6.15371 8.15494L10.2057 12.8309C10.3732 13.024 10.5787 13.1806 10.8093 13.2908C11.04 13.401 11.2908 13.4625 11.5463 13.4716C11.8017 13.4806 12.0563 13.437 12.2942 13.3434C12.532 13.2497 12.7481 13.1081 12.9288 12.9274C13.1096 12.7466 13.2512 12.5306 13.3448 12.2928C13.4384 12.0549 13.4821 11.8003 13.473 11.5448C13.464 11.2894 13.4024 11.0385 13.2922 10.8079C13.182 10.5773 13.0255 10.3718 12.8324 10.2043L8.15704 6.1516L8.80504 5.5036C9.15136 5.55308 9.50447 5.49233 9.81434 5.32996C10.1242 5.16759 10.3751 4.91183 10.5316 4.59891C10.688 4.28599 10.742 3.93178 10.6859 3.58647C10.6298 3.24116 10.4665 2.92226 10.219 2.67494L8.33371 0.79027C8.08636 0.542767 7.76738 0.379394 7.42199 0.323308C7.07659 0.267222 6.72231 0.321267 6.40935 0.477784C6.09639 0.634302 5.84063 0.88535 5.67832 1.19535C5.51601 1.50534 5.45539 1.85856 5.50504 2.20494L2.20505 5.50427C1.94904 5.4676 1.68801 5.49111 1.44268 5.57292C1.19735 5.65474 0.974461 5.79261 0.791712 5.9756L0.791045 5.97494ZM7.62704 4.79694L4.79904 7.62494L3.38438 6.21094L6.21304 3.38227L7.62704 4.79694ZM1.73371 7.3896C1.70272 7.35866 1.67813 7.32191 1.66134 7.28145C1.64455 7.241 1.63589 7.19764 1.63586 7.15384C1.63583 7.11004 1.64442 7.06667 1.66116 7.02619C1.67789 6.98571 1.70243 6.94893 1.73338 6.91794C1.76433 6.88695 1.80108 6.86235 1.84153 6.84556C1.88198 6.82877 1.92534 6.82012 1.96914 6.82009C2.01294 6.82005 2.05632 6.82865 2.09679 6.84538C2.13727 6.86211 2.17405 6.88666 2.20505 6.9176L4.09105 8.8036C4.12288 8.83435 4.14828 8.87113 4.16575 8.9118C4.18321 8.95247 4.19241 8.99621 4.1928 9.04047C4.19318 9.08473 4.18475 9.12862 4.16799 9.16959C4.15123 9.21055 4.12647 9.24777 4.09518 9.27907C4.06388 9.31037 4.02666 9.33512 3.9857 9.35188C3.94473 9.36864 3.90084 9.37707 3.85658 9.37669C3.81232 9.3763 3.76858 9.36711 3.72791 9.34964C3.68724 9.33217 3.65046 9.30677 3.61971 9.27494L1.73371 7.3896ZM6.91904 2.2036C6.88721 2.17285 6.86181 2.13607 6.84434 2.0954C6.82687 2.05474 6.81768 2.011 6.81729 1.96674C6.81691 1.92248 6.82534 1.87858 6.8421 1.83762C6.85886 1.79665 6.88362 1.75944 6.91491 1.72814C6.94621 1.69684 6.98343 1.67209 7.02439 1.65533C7.06536 1.63857 7.10925 1.63014 7.15351 1.63052C7.19777 1.6309 7.24151 1.6401 7.28218 1.65757C7.32285 1.67504 7.35963 1.70043 7.39038 1.73227L9.27638 3.61827C9.30821 3.64902 9.33361 3.6858 9.35108 3.72647C9.36855 3.76714 9.37774 3.81088 9.37813 3.85514C9.37851 3.8994 9.37008 3.94329 9.35332 3.98425C9.33656 4.02522 9.31181 4.06244 9.28051 4.09374C9.24921 4.12503 9.21199 4.14978 9.17103 4.16654C9.13006 4.1833 9.08617 4.19174 9.04191 4.19135C8.99765 4.19097 8.95391 4.18177 8.91324 4.1643C8.87257 4.14683 8.83579 4.12144 8.80504 4.0896L6.91904 2.2036ZM11.2137 11.9576L7.20838 7.33627L7.33771 7.20627L11.9597 11.2116C12.0129 11.2596 12.0558 11.318 12.0858 11.3832C12.1158 11.4483 12.1322 11.5189 12.134 11.5905C12.1359 11.6622 12.1231 11.7335 12.0965 11.8001C12.0699 11.8667 12.03 11.9272 11.9793 11.9779C11.9286 12.0286 11.8682 12.0685 11.8016 12.0951C11.735 12.1216 11.6637 12.1344 11.592 12.1326C11.5203 12.1307 11.4497 12.1143 11.3846 12.0844C11.3195 12.0544 11.2611 12.0115 11.213 11.9583L11.2137 11.9576Z"
                        fill="#4A71E0"
                      />
                    </svg>
                  </Tooltip>
                )}
              {propertieItem?.auction &&
                propertieItem.auction.auction_type === "online" && (
                  <Tooltip
                    className="icon-wrapper"
                    color="white"
                    title={
                      <p className="tooltip-color">
                        {t("property_details_auction.tooltips.online")}
                      </p>
                    }
                  >
                    <svg
                      width="20"
                      height="20"
                      viewBox="0 0 20 20"
                      fill="none"
                      xmlns="http://www.w3.org/2000/svg"
                    >
                      <path
                        fill-rule="evenodd"
                        clip-rule="evenodd"
                        d="M1.2002 8.0002C1.2002 8.89318 1.37608 9.77743 1.71781 10.6024C2.05955 11.4275 2.56043 12.1771 3.19187 12.8085C3.82331 13.44 4.57293 13.9408 5.39795 14.2826C6.22296 14.6243 7.10721 14.8002 8.0002 14.8002C8.89318 14.8002 9.77743 14.6243 10.6024 14.2826C11.4275 13.9408 12.1771 13.44 12.8085 12.8085C13.44 12.1771 13.9408 11.4275 14.2826 10.6024C14.6243 9.77743 14.8002 8.89318 14.8002 8.0002C14.8002 6.19672 14.0838 4.46712 12.8085 3.19187C11.5333 1.91662 9.80367 1.2002 8.0002 1.2002C6.19672 1.2002 4.46712 1.91662 3.19187 3.19187C1.91662 4.46712 1.2002 6.19672 1.2002 8.0002ZM14.0002 8.0002C14.0002 9.59149 13.3681 11.1176 12.2428 12.2428C11.1176 13.3681 9.59149 14.0002 8.0002 14.0002C6.4089 14.0002 4.88277 13.3681 3.75755 12.2428C2.63234 11.1176 2.0002 9.59149 2.0002 8.0002C2.0002 6.4089 2.63234 4.88277 3.75755 3.75755C4.88277 2.63234 6.4089 2.0002 8.0002 2.0002C9.59149 2.0002 11.1176 2.63234 12.2428 3.75755C13.3681 4.88277 14.0002 6.4089 14.0002 8.0002Z"
                        fill="#4A71E0"
                      />
                      <path
                        fill-rule="evenodd"
                        clip-rule="evenodd"
                        d="M5.2002 8.00059C5.2002 11.5174 6.3538 14.4006 8.0002 14.4006C9.6466 14.4006 10.8002 11.5174 10.8002 8.00059C10.8002 4.48379 9.6466 1.60059 8.0002 1.60059C6.3538 1.60059 5.2002 4.48379 5.2002 8.00059ZM10.0002 8.00059C10.0002 11.1118 9.0042 13.6006 8.0002 13.6006C6.9962 13.6006 6.0002 11.1118 6.0002 8.00059C6.0002 4.88939 6.9962 2.40059 8.0002 2.40059C9.0042 2.40059 10.0002 4.88939 10.0002 8.00059Z"
                        fill="#4A71E0"
                      />
                      <path
                        d="M2.9881 4.24985L3.5241 3.65625C3.6097 3.73305 3.7009 3.80825 3.7985 3.88105C4.8529 4.67145 6.5169 5.15305 8.3305 5.15305C9.8769 5.15305 11.3201 4.80345 12.3745 4.20105C12.6174 4.0636 12.847 3.9037 13.0601 3.72345L13.5801 4.33145C13.3417 4.53545 13.0713 4.72345 12.7721 4.89465C11.5905 5.57065 10.0105 5.95305 8.3305 5.95305C6.3545 5.95305 4.5209 5.42265 3.3185 4.52105C3.20425 4.4355 3.094 4.34554 2.9881 4.24985ZM2.9881 11.7602L3.5241 12.3522C3.6097 12.2754 3.7009 12.2003 3.7985 12.1283C4.8529 11.3379 6.5169 10.8563 8.3305 10.8563C9.8769 10.8563 11.3201 11.2051 12.3745 11.8083C12.6313 11.9555 12.8609 12.1154 13.0601 12.285L13.5801 11.677C13.3289 11.4645 13.0584 11.2759 12.7721 11.1139C11.5905 10.4387 10.0105 10.0562 8.3305 10.0562C6.3545 10.0562 4.5209 10.5866 3.3185 11.4874C3.2017 11.5754 3.0913 11.6666 2.9881 11.7602ZM1.6001 8.40025V7.60025H14.4001V8.40025H1.6001Z"
                        fill="#4A71E0"
                      />
                    </svg>
                  </Tooltip>
                )}
            </div>
          </>
        )}

        {type === "auction" && (
          <div className="contact-info">
            {propertieItem?.user_property_ref_id && (
              <Tooltip
                color="white"
                title={
                  <p className="tooltip-color">{t("properties.propertyNo")}</p>
                }
              >
                <p className="ref-id">{propertieItem?.user_property_ref_id}</p>
              </Tooltip>
            )}
            {propertieItem?.user_details?.selling_agent?.image && (
              <img
                src={propertieItem?.user_details?.selling_agent?.image}
                alt="logo"
                className="logo_property"
              />
            )}
            {category === "current" && (
              <Button
                onClick={() => setOpen(true)}
                className="btnrange_absolute_btn green-bg"
              >
                {t("auction_elements.start_auction")}
              </Button>
            )}
            {category === "future" && (
              <Tooltip
                className="icon-wrapper"
                color="white"
                title={
                  <p className="tooltip-color">
                    {t("property_details_auction.tooltips.notify_btn")}
                  </p>
                }
              >
                <Button className="btnrange_absolute_btn green-bg">
                  {t("auction_elements.notify")}
                </Button>
              </Tooltip>
            )}
            {category === "ended" && (
              <Button disabled className="btnrange_absolute_btn ">
                {propertieItem?.auction?.ended_status === "sold"
                  ? t("auction_elements.sold")
                  : t("auction_elements.postponed")}
              </Button>
            )}
          </div>
        )}
      </div>
    </div>
  );
}

export default ActionCard;
